import styled from "styled-components"

export const ReasonWrapper = styled.div`
margin-top: 1rem;
`

